import { makeVar } from '@apollo/client';

export const OPENED_MODAL = makeVar<
  'PASSWORD_UPDATE' | 'SESSION_EXPIRED' | null
>(null);

export const REFETCH_APP_SETTINGS = makeVar(false);
